
import PageLayout from "@/components/layout/PageLayout";
import ContactHero from "@/components/contact/ContactHero";
import { Helmet } from "react-helmet-async";

const Contact = () => {
  return (
    <PageLayout>
      <Helmet>
        <title>Contact - FORESTT-HUB</title>
        <meta name="description" content="Contactez l'équipe du GIP ECOFOR qui coordonne le projet FORESTT-HUB pour toute information concernant nos projets de recherche sur les forêts." />
      </Helmet>
      
      <ContactHero />
    </PageLayout>
  );
};

export default Contact;
